import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { ChatbotComponent } from './chatbot/chatbot.component';


const routes: Routes = [
  {path: '', component: ChatbotComponent},
]


@NgModule({
  declarations: [
    ChatbotComponent
  ],
  imports: [
    CommonModule,
    //RouterModule.forRoot(routes),
    HttpClientModule,
    FormsModule
  ],
  exports: [
    RouterModule,
    ChatbotComponent
  ],
})
export class BotModule { }

